import { defineStore } from 'pinia';

const useAppConfig = defineStore('appConfig', {
	state: (): AppConfigState => ({
		code: undefined,
	}),
	actions: {
		setCode(code: string) {
			this.code = code;
		},
	},
});

export default useAppConfig();
